export default $axios => {
    return {
        $axios,

        async fetch() {
            return await $axios.get('/materials'); 
        }
    }
}